import React from 'react';
import { Loader } from 'lucide-react';
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

const DrillDownCard = ({
  icon,
  title,
  count,
  description,
  color,
  route,
  actionText,
  isLoading,
}) => {
  const priority = count > 10
  ? 'urgent'
  : count > 5
    ? 'monitor'
    : 'healthy';

  // Badge style based on priority level
  const getBadgeColor = () => {
    switch(priority) {
      case 'urgent':
        return 'bg-red-100 text-red-800';
      case 'monitor':
        return 'bg-yellow-100 text-yellow-800';
      case 'healthy':
      default:
        return 'bg-green-100 text-green-800';
    }
  };
  
  // Priority indicator text
  const getPriorityText = () => {
    switch(priority) {
      case 'urgent':
        return 'Urgent';
      case 'monitor':
        return 'Monitor';
      case 'healthy':
      default:
        return 'Healthy';
    }
  };

  return (
    <Card className={`${color} shadow-md hover:shadow-lg transition-shadow border-l-4 ${
      priority === 'urgent' ? 'border-l-red-500' : 
      priority === 'monitor' ? 'border-l-yellow-500' : 
      'border-l-green-500'
    }`}>
      <CardContent className="p-4">
        {/* Card Header with Icon and Title */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            {isLoading ? <Loader size={24} className="animate-spin"/> : icon}
            <h3 className="font-semibold">{title}</h3>
          </div>
          <div className={`text-xs px-2 py-1 rounded-full ${getBadgeColor()}`}>
            {getPriorityText()}
          </div>
        </div>
        
        {/* Card Body with Metrics and CTA Button - Now inline */}
        <div className="flex flex-col gap-2 items-center justify-between xl:flex-row">
          <div className="flex gap-1 items-center">
            <span className="text-2xl font-bold">{count}</span>
            <span className="text-sm text-gray-600">{description}</span>
          </div>
          
          <Button 
            variant="outline" 
            size="sm" 
            className="h-auto lg:text-sm text-xs py-1.5 px-3"
            asChild
          >
            <Link to={route}>{actionText}</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default DrillDownCard;
